<script>
import axios from "axios";
import ListPreloader from './components/ListPreloader.vue'
export default {
  components: {ListPreloader},
  props: {
    uploadedImportFile: Object
  },
  emits: {
    back: null
  },
  data(){
    return {
      media: null,
      requestUpdateId: null
    }
  },
  watch: {
  },
  methods: {
    token(){
      return this.$root.$el.parentElement.dataset.token
    },
    requestMediaState(delay){
      clearTimeout(this.requestUpdateId)
      this.requestUpdateId = setTimeout(() => this.updateMediaState(), delay ?? 5000)
    },
    updateMediaState(){
      axios.get(`${this.basePath()}api/media/status`, {
        params: {
          hash: this.uploadedImportFile.hash,
        }
      }).then( response => {

        this.media = response.data
        if(['import_queued', 'import_progress'].indexOf(this.media.state) >=0){
          this.requestMediaState()
        }else{
          this.$emit('back')
        }

      }).catch(error => {
      }).finally(() => {
      })
    },
    onDelete(){
      global.openConfirmModal({
        title: this.$t('confirm:delete item'),
        ok: {
          title: this.$t('yes'),
          callback: function (){
            this.requestMediaDelete()
          }.bind(this)
        },
        cancel: {}
      })
    },
    requestMediaDelete(){
      axios.postForm(`${this.basePath()}api/media/delete`, {
        _token: this.token(),
        hash: this.uploadedImportFile.hash,
      }).then( response => {
        this.$emit('back')
      })
      clearTimeout(this.requestUpdateId)
    },
  },
  mounted() {
    this.media = this.uploadedImportFile
    this.requestMediaState()
  },
}
</script>

<template>

  <div class="d-flex border-bottom align-items-center gap-3 py-2" v-if="this.media !== null">
    <i class="ph ph-file-xls fs-2"></i>
    <div class="flex-fill text-start">
      <small>{{ media.size }} | {{ media.ext }}</small>
      <div>{{ media.title }}</div>
    </div>
    <div class="d-flex align-items-center gap-2" :class="`text-${media.state_style}`" v-if="media.state_name">
      <i :class="media.state_icon"></i>
      {{ media.state_name }}
      <template v-if="media.state === 'import_failed' && media.parameters?.error">: {{ media.parameters.error || '' }}</template>
      <template v-if="media.state === 'import_progress' && media.parameters?.import_total_rows"> ({{ media.parameters?.import_completed_rows }} / {{ media.parameters?.import_total_rows }})</template>
    </div>
    <div class="actions dropdown">
      <button class="btn btn-link p-0 border-0 text-dark hover-dark" type="button" id="actionsDropdown-88" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Actions">
        <i class="ph ph-dots-three-vertical" aria-hidden="true"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="actionsDropdown-88">
        <li>
          <button type="button" class="dropdown-item" @click="onDelete(media)">
            {{ $t('delete') }}
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div style="height: 400px" class="position-relative">
    <ListPreloader text="lists: loading items list"/>
  </div>



</template>

<style scoped>
</style>